import { DateTime } from 'luxon';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const STATUS_CONFIG: Record<string, { label: string; color: string }> = {
  queued: { label: 'Queued', color: '#ed6c02' },
  processing: { label: 'Processing', color: '#1976d2' },
  done: { label: 'Done', color: '#2e7d32' }
};

// D93 access tiers. Colours signal how gated the artifact is:
// public = open (green), client = client-shared/gated (blue),
// internal = team-only (red).
const ACCESS_LEVEL_CONFIG: Record<string, { label: string; color: string }> = {
  public: { label: 'Public', color: '#2e7d32' },
  client: { label: 'Client', color: '#1976d2' },
  internal: { label: 'Internal', color: '#d32f2f' }
};

interface GenerateRowsCallbacks {
  onMenuOpen: (artifact: Artifact, event: React.MouseEvent<HTMLElement>) => void;
}

const generateRows = (
  artifacts: Artifact[],
  callbacks: GenerateRowsCallbacks
): TableRow[] =>
  artifacts.map((artifact) => {
    const { onMenuOpen } = callbacks;
    const isJob = !!(artifact as any).jobId;
    const status = (artifact as any).status || 'done';
    const statusInfo = STATUS_CONFIG[status] || STATUS_CONFIG.done;

    const payload: TableRow = {
      id: artifact.id,
      title: artifact.title || 'Untitled',
      description: {
        type: 'text',
        data: {
          text: artifact.description || 'No description'
        }
      },
      type: {
        type: 'chip',
        data: [{
          text: artifact.type === 'report' ? 'Core' : artifact.type === 'negotiator' ? 'Negotiator' : artifact.type === 'cohort' ? 'Cohort' : artifact.type === 'mortgage' ? 'Mortgage' : 'Other',
          backgroundColor: artifact.type === 'report' ? '#1976d2' : artifact.type === 'negotiator' ? 'rgb(240, 207, 105)' : artifact.type === 'cohort' ? '#7b1fa2' : artifact.type === 'mortgage' ? '#7C3AED' : '#9e9e9e'
        }]
      },
      accessLevel: artifact.accessLevel
        ? (() => {
            const info = ACCESS_LEVEL_CONFIG[artifact.accessLevel] ||
              { label: artifact.accessLevel, color: '#9e9e9e' };
            return {
              type: 'chip' as const,
              data: [{ text: info.label, backgroundColor: info.color }]
            };
          })()
        : '—',
      status: {
        type: 'chip',
        data: [{
          text: statusInfo.label,
          backgroundColor: statusInfo.color
        }]
      },
      dateRange:
        artifact.startDate && artifact.endDate
          ? `${DateTime.fromISO(artifact.startDate).toFormat('LLL dd, yyyy')} to ${DateTime.fromISO(artifact.endDate).toFormat('LLL dd, yyyy')}`
          : 'N/A',
      createdAt: artifact.createdAt
        ? DateTime.fromISO(artifact.createdAt).toLocaleString(DateTime.DATETIME_MED)
        : '',
      actions: isJob
        ? ''
        : {
            type: 'action',
            data: [
              {
                type: 'other',
                icon: MoreVertIcon,
                linkData: {
                  onClick: (event: unknown) =>
                    onMenuOpen(artifact, event as React.MouseEvent<HTMLElement>)
                }
              }
            ]
          }
    };

    return payload;
  });

export default generateRows;
